import { intl } from '@beelday/common'
import { FC } from 'react'
import { presentButtonState } from './model/console-view'
import { PresenterHint } from './model/presentation-machine'
import { usePresenterConsole } from './presenter-console'
import { PresentButton } from './presentation/present-button'

const HINT_KEYS: Record<PresenterHint, string> = {
	'allowed-click-again': 'in_person.presenter.hint.allowed_click_again',
	denied: 'in_person.presenter.hint.denied',
	'popups-blocked': 'in_person.presenter.hint.popups_blocked',
	'drag-to-projector': 'in_person.presenter.hint.drag_to_projector',
	'click-on-projector': 'in_person.presenter.hint.click_on_projector',
}

export const ConfiguredPresentButton: FC = () => {
	const presenter = usePresenterConsole()
	const translate = intl.useTranslate()
	if (!presenter) {
		return null
	}
	const { state, path } = presenter
	const hint = 'hint' in state ? state.hint : undefined

	return (
		<PresentButton
			state={presentButtonState(state)}
			offerHere={path === 'manual'}
			hintKey={hint ? HINT_KEYS[hint] : undefined}
			presentTitle={
				path === 'single'
					? translate('in_person.presenter.hint.extend')
					: undefined
			}
			onPresent={presenter.present}
			onPresentHere={presenter.presentHere}
			onShowFullscreen={presenter.showFullscreen}
			onLeaveFullscreen={presenter.end}
			onEnd={presenter.end}
		/>
	)
}

export default ConfiguredPresentButton
